import React from 'react'
import { observer } from 'mobx-react'
import { translate as loc, dict } from 'Localisation'
import asideModalStore from 'Stores/asideModalStore'
import DummyCounter from 'components/ContentBox/Global/Counter/DummyCounter'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import './EmployeeContract.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'

const hourTypeOptions = [
  { id: 45, name: loc(dict.main_page.text_8) },
  { id: 60, name: loc(dict.main_page.text_9) },
]

const ContractPlans = () => {
  const { modalValues, changeValue } = asideModalStore

  const onHourTypeChange = (hourType) => {
    changeValue(0, 'test_plan_mins')
    changeValue(hourType, 'hour_type')
  }

  return (
    <div className='super-modal__form-column'>
      <FormField>
        <FormLabel>{loc(dict.main_page.text_10)}:</FormLabel>
        <div className='mainSelectorBlock'>
          <div className='super-modal__form-row2'>
            <FormField>
              <FormLabel>{loc(dict.main_page.text_4)}:</FormLabel>
              <DummyCounter
                name='test_plan_mins'
                value={modalValues.test_plan_mins / 60 || 0}
                onChange={(val, key) => changeValue(val * 60, key)}
                min={0.5}
                step={0.5}
              />
            </FormField>
            <FormField>
              <FormLabel>{loc(dict.main_page.text_5)}:</FormLabel>
              <SelectCustom
                placeholder={loc(dict.main_page.text_5)}
                options={hourTypeOptions}
                valueID={modalValues.hour_type}
                onChange={(o) => onHourTypeChange(o.id)}
              />
            </FormField>
          </div>
          <div>
            <p className='modalEmployerContract__link'>
              {loc(dict.main_page.text_6)}:
            </p>
          </div>
        </div>
      </FormField>
      <FormField>
        <FormLabel>{loc(dict.main_page.text_10_1)}:</FormLabel>
        <div className='mainSelectorBlock'>
          <div className='super-modal__form-row2'>
            <FormField>
              <FormLabel>{loc(dict.main_page.text_4)}:</FormLabel>
              <DummyCounter
                name='teaching_plan_mins'
                value={
                  modalValues.teaching_plan_mins /
                    modalValues.teaching_plan_hour_type || 0
                }
                onChange={(val, key) =>
                  changeValue(val * modalValues.teaching_plan_hour_type, key)
                }
                min={0.5}
                step={0.5}
              />
            </FormField>
            <FormField>
              <FormLabel>{loc(dict.main_page.text_5)}:</FormLabel>
              <SelectCustom
                placeholder={loc(dict.main_page.text_5)}
                options={hourTypeOptions}
                valueID={modalValues.teaching_plan_hour_type}
                onChange={(o) => changeValue(o.id, 'teaching_plan_hour_type')}
              />
            </FormField>
          </div>
          <div>
            <p className='modalEmployerContract__link'>
              {loc(dict.main_page.text_6_1)}
            </p>
          </div>
        </div>
      </FormField>
    </div>
  )
}

export default observer(ContractPlans)
